<div class="w-100" [ngClass]="{ 'position-relative' : options.defaultRelative  }">
    <input type="text" [(ngModel)]="address" [ngClass]="options.classes" (keyup)="search($event)" placeholder="{{ 'Standard.Address' | translate }}" (blur)="doneSearching()" autocomplete="dontUse" (change)="addressEntered($event)">
    <div class="position-absolute w-100 flex-column bg-white border dawaResultContainer" *ngIf="searching" [ngStyle]="{
        'z-index' : options.zIndex, 
        'max-height': resultsMaxHeight + 'px', 
        'min-height':'6rem', 
        'overflow-y':'auto'
    }" [ngClass]="searching ? 'd-flex' : 'd-none'">
        <ng-container *ngFor="let address of dawaResults">
            <div class="dawaAddress d-flex flex-column p-3 gap-1 justify-content-center" (click)="pickAddress(address)">
                <div>{{ addressWithoutZipCity(address.tekst, address.adresse.postnr, address.adresse.postnrnavn) }}</div>
                <div class="d-flex gap-1 font-weight-bold">{{ address.adresse.postnr }} {{ address.adresse.postnrnavn }}</div>
            </div>
        </ng-container>
    </div>
</div>
